import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PriceChangeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"price_change"}/>
}
